import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import Cookies from 'js-cookie';

import { UserApplication, switchUserApplication } from '@auth_module/services';
import { QUERY_KEYS } from '@constants/queryKeys';
import { STORAGE_KEY } from '@auth_module/constants/storageKeys';

export const useSwitchUserApplication = () => {
  const [selectedApp, setSelectedApp] = useState<UserApplication | null>(null);

  const selectedAppAsParam = useMemo(() => {
    if (selectedApp === 'api') {
      return 'promohub';
    }
    return selectedApp;
  }, [selectedApp]);

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.SELECTED_APPLICATION],
    queryFn: () => selectedAppAsParam && switchUserApplication({ app: selectedAppAsParam }),
    enabled: !!selectedAppAsParam,
  });

  useEffect(() => {
    if (data?.data?.token) {
      Cookies.set(STORAGE_KEY.auth_token, data.data.token);

      if (selectedApp === 'api') {
        window.location.replace('/account/self-service-api');
      } else {
        window.location.replace('/');
      }
      setSelectedApp(null);
    }
  }, [data]);

  return {
    switchTo: setSelectedApp,
    isLoading: isLoading && !!selectedApp,
  };
};
